import router from '@/plugins/router'
import { onboardingLocation } from '@/utils/auth-redirect'

/**
 * Check whether an API error indicates missing or invalid consent.
 * Works with the plain error objects produced by the Axios response interceptor.
 */
export function isConsentError(error) {
  const message = error?.message || error?.code || ''
  return typeof message === 'string' && message.toLowerCase().includes('consent')
}

/**
 * Clear stale consent state and redirect to the onboarding flow, which resumes
 * the auth screen afterwards.
 * Accepts the destructured Vuex action context ({ commit }) from within
 * the auth module — commit is already module-scoped.
 */
export function handleConsentError({ commit }) {
  commit('setOnboardingConsent', null)

  router.replace(onboardingLocation(router.currentRoute.value))
}
